import * as Glyph from "./glyphs";
import * as Nav from "./nav";
import * as Service from "./services";
import * as Identity from "./identity";
import * as Indicator from "./indicators";

enum CKIconVariant {
  "Glyphs" = "Glyphs",
  "Nav" = "Nav",
  "Services" = "Services",
  "Identity" = "Identity",
  "Indicators" = "Indicators"
}

export { CKIconVariant };

export const CKIcons = {
  [CKIconVariant.Glyphs]: Glyph,
  [CKIconVariant.Nav]: Nav,
  [CKIconVariant.Services]: Service,
  [CKIconVariant.Identity]: Identity,
  [CKIconVariant.Indicators]: Indicator
};

export * from "./CKIconGradient";
